"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = Item;
exports.ItemActions = ItemActions;
exports.ItemContent = ItemContent;
exports.ItemDescription = ItemDescription;
exports.ItemFooter = ItemFooter;
exports.ItemGroup = ItemGroup;
exports.ItemHeader = ItemHeader;
exports.ItemMedia = ItemMedia;
exports.ItemSeparator = ItemSeparator;
exports.ItemTitle = ItemTitle;
var React = _interopRequireWildcard(require("react"));
var _classVarianceAuthority = require("class-variance-authority");
var _utils = require("@design/lib/utils");
var _radixUi = require("radix-ui");
var _separator = require("@design/ui/separator");
var _truncatedText = require("@design/ui/truncated-text");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className"],
  _excluded2 = ["className"],
  _excluded3 = ["className", "variant", "size", "asChild"],
  _excluded4 = ["className", "variant"],
  _excluded5 = ["className"],
  _excluded6 = ["className", "children"],
  _excluded7 = ["className"],
  _excluded8 = ["className"],
  _excluded9 = ["className"],
  _excluded0 = ["className"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ItemGroup(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    role: "list",
    "data-slot": "item-group",
    className: (0, _utils.cn)("group/item-group flex w-full flex-col gap-4 has-data-[size=sm]:gap-2.5 has-data-[size=xs]:gap-2", className)
  }, props), {}, {
    "data-sentry-component": "ItemGroup",
    "data-sentry-source-file": "item.tsx"
  }));
}
function ItemSeparator(_ref2) {
  var className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_separator.Separator, _objectSpread(_objectSpread({
    "data-slot": "item-separator",
    orientation: "horizontal",
    className: (0, _utils.cn)("my-2", className)
  }, props), {}, {
    "data-sentry-element": "Separator",
    "data-sentry-component": "ItemSeparator",
    "data-sentry-source-file": "item.tsx"
  }));
}
var itemVariants = (0, _classVarianceAuthority.cva)("group/item flex w-full flex-wrap items-center rounded-md border text-sm transition-colors duration-100 outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 [a]:transition-colors [a]:hover:bg-muted [button]:text-left [button]:hover:bg-muted", {
  variants: {
    variant: {
      default: "border-transparent",
      outline: "border-border",
      muted: "border-transparent bg-muted/50"
    },
    size: {
      default: "gap-3.5 px-4 py-3.5",
      sm: "gap-2.5 px-3 py-2.5",
      xs: "gap-2 px-2.5 py-2 in-data-[slot=dropdown-menu-content]:p-0"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
});
function Item(_ref3) {
  var className = _ref3.className,
    _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? "default" : _ref3$variant,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? "default" : _ref3$size,
    _ref3$asChild = _ref3.asChild,
    asChild = _ref3$asChild === void 0 ? false : _ref3$asChild,
    props = _objectWithoutProperties(_ref3, _excluded3);
  var Comp = asChild ? _radixUi.Slot.Root : "div";
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Comp, _objectSpread(_objectSpread({
    "data-slot": "item",
    "data-variant": variant,
    "data-size": size,
    className: (0, _utils.cn)(itemVariants({
      variant: variant,
      size: size,
      className: className
    }))
  }, props), {}, {
    "data-sentry-element": "Comp",
    "data-sentry-component": "Item",
    "data-sentry-source-file": "item.tsx"
  }));
}
var itemMediaVariants = (0, _classVarianceAuthority.cva)("flex shrink-0 items-center justify-center gap-2 group-has-data-[slot=item-description]/item:translate-y-0.5 group-has-data-[slot=item-description]/item:self-start [&_svg]:pointer-events-none", {
  variants: {
    variant: {
      default: "bg-transparent",
      icon: "[&_svg:not([class*='size-'])]:size-4",
      image: "size-10 overflow-hidden rounded-sm group-data-[size=sm]/item:size-8 group-data-[size=xs]/item:size-6 [&_img]:size-full [&_img]:object-cover"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
function ItemMedia(_ref4) {
  var className = _ref4.className,
    _ref4$variant = _ref4.variant,
    variant = _ref4$variant === void 0 ? "default" : _ref4$variant,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "item-media",
    "data-variant": variant,
    className: (0, _utils.cn)(itemMediaVariants({
      variant: variant,
      className: className
    }))
  }, props), {}, {
    "data-sentry-component": "ItemMedia",
    "data-sentry-source-file": "item.tsx"
  }));
}
function ItemContent(_ref5) {
  var className = _ref5.className,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "item-content",
    className: (0, _utils.cn)("flex min-w-0 flex-1 flex-col gap-1 group-data-[size=xs]/item:gap-0 [&+[data-slot=item-content]]:flex-none", className)
  }, props), {}, {
    "data-sentry-component": "ItemContent",
    "data-sentry-source-file": "item.tsx"
  }));
}
function ItemTitle(_ref6) {
  var className = _ref6.className,
    children = _ref6.children,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "item-title",
    className: (0, _utils.cn)("flex w-fit min-w-0 max-w-full items-center gap-2 text-sm leading-5 font-medium underline-offset-4", className)
  }, props), {}, {
    "data-sentry-component": "ItemTitle",
    "data-sentry-source-file": "item.tsx",
    children: (0, _truncatedText.truncateTextChildren)(children)
  }));
}
function ItemDescription(_ref7) {
  var className = _ref7.className,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", _objectSpread(_objectSpread({
    "data-slot": "item-description",
    className: (0, _utils.cn)("fit-wrap line-clamp-2 text-left text-sm leading-5 font-normal text-muted-foreground group-data-[size=xs]/item:text-xs [&>a]:underline [&>a]:underline-offset-4 [&>a:hover]:text-primary", className)
  }, props), {}, {
    "data-sentry-component": "ItemDescription",
    "data-sentry-source-file": "item.tsx"
  }));
}
function ItemActions(_ref8) {
  var className = _ref8.className,
    props = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "item-actions",
    className: (0, _utils.cn)("flex items-center gap-2", className)
  }, props), {}, {
    "data-sentry-component": "ItemActions",
    "data-sentry-source-file": "item.tsx"
  }));
}
function ItemHeader(_ref9) {
  var className = _ref9.className,
    props = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "item-header",
    className: (0, _utils.cn)("flex basis-full items-center justify-between gap-2", className)
  }, props), {}, {
    "data-sentry-component": "ItemHeader",
    "data-sentry-source-file": "item.tsx"
  }));
}
function ItemFooter(_ref0) {
  var className = _ref0.className,
    props = _objectWithoutProperties(_ref0, _excluded0);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "item-footer",
    className: (0, _utils.cn)("flex basis-full items-center justify-between gap-2", className)
  }, props), {}, {
    "data-sentry-component": "ItemFooter",
    "data-sentry-source-file": "item.tsx"
  }));
}